// @helpers
const { on, off } = require('commonsUtilities/scrollUtils');

const ViewportHelper = {
    /**
     * Check if element is in viewport of parent (by default, window).
     *
     * @param { Object } whichElement Node to check if it is in viewport of @parent.
     * @param { Object | undefined } [parent = window]
     * @param { number } [marginExtra = 50]
     * @returns { boolean }
     */
    isElementInViewport: (whichElement, parent = window, marginExtra = 50) => {
        if (!whichElement) {
            return false;
        }

        const width = whichElement.offsetWidth;
        const height = whichElement.offsetHeight;

        let element = whichElement;

        let top = element.offsetTop;
        let left = element.offsetLeft;

        while (element.offsetParent) {
            element = element.offsetParent;
            top += element.offsetTop;
            left += element.offsetLeft;
        }

        return (
            top >= parent.pageYOffset - marginExtra &&
            left >= parent.pageXOffset &&
            (top + height) <= (parent.pageYOffset + parent.innerHeight + marginExtra) &&
            (left + width) <= (parent.pageXOffset + parent.innerWidth)
        );
    },

    /**
     * Call a function when element is in viewport of parent.
     *
     * @param { Object } whichElement
     * @param { Object | undefined } [parent = window]
     * @param { Function } onViewportHandler Callback executed when @whichElement is in viewport of @parent.
     * @returns { Function } Handler, useful to remove callback and stop listening for 'element in viewport' event.
     */
    onElementInViewport: (whichElement, parent = window, onViewportHandler) => {
        const checkViewportAndExecuteCallback = () => {
            if (ViewportHelper.isElementInViewport(whichElement, parent) && onViewportHandler) {
                onViewportHandler();
            }
        };

        // Element might be in viewport without scrolling
        checkViewportAndExecuteCallback();

        return on(parent, checkViewportAndExecuteCallback);
    },

    removeElementInViewportHandler: (parent = window, handlerFunc) => {
        off(parent, handlerFunc);
    }
};

module.exports = ViewportHelper;
